import type { LocationSuggestion } from "@/api/types";

export function formatLocationLabel(name: string, region: string | null): string {
  return region ? `${name}, ${region}` : name;
}

export function formatLocationSuggestion(suggestion: LocationSuggestion): string {
  return formatLocationLabel(suggestion.name, suggestion.region);
}
